export function buildFileList(data: File) {
    let dataTransfer = new DataTransfer();
    dataTransfer.items.add(data);
    return dataTransfer.files;
}